/* @ngInject */

export default ($rootScope, helperService, helperPdfService, Address) => {
  /**
   * Prepare about us details.
   *
   * @param {Object} ticketOwner
   * @param {Boolean} showCreditLicenceDetails
   *
   * @returns {Array}
   */
  const prepareAboutUsDetails = ({ ticketOwner, showCreditLicenceDetails }) => {
    const content = [];
    if (ticketOwner) {
      content.push({
        text: '',
        margin: [0, 20, 0, 0]
      });
      content.push(
        helperPdfService.createHeader({
          title: 'ABOUT US'
        })
      );
      content.push(
        helperPdfService.createSubHeader({
          title: 'CREDIT REPRESENTATIVE DETAILS'
        })
      );
      content.push({
        table: {
          widths: ['25%', '25%', '25%', '25%'],
          body: [
            [
              {
                text: [
                  {
                    text: 'Credit representative name\n',
                    style: 'label'
                  },
                  {
                    text: ticketOwner.getName(),
                    style: 'value'
                  }
                ]
              },
              {
                text: [
                  { text: 'Credit representative number\n', style: 'label' },
                  {
                    text: ticketOwner?.user?.licenses?.id2 || '-',
                    style: 'value'
                  }
                ]
              },
              {
                text: [
                  {
                    text: 'AFCA membership number\n',
                    style: 'label'
                  },
                  {
                    text: ticketOwner?.user?.licenses?.in3 || '-',
                    style: 'value'
                  }
                ]
              },
              {
                text: [
                  { text: 'Email\n', style: 'label' },
                  {
                    text: ticketOwner?.user?.eMail || '-',
                    style: 'value'
                  }
                ]
              }
            ],
            [
              {
                text: [
                  { text: 'Mobile phone\n', style: 'label' },
                  {
                    text: `${ticketOwner?.user?.phone ? ticketOwner?.user?.prefix : ''} ${
                      ticketOwner?.user?.phone || '-'
                    }`,
                    style: 'value'
                  }
                ]
              },
              {
                text: [
                  {
                    text: 'Business name\n',
                    style: 'label'
                  },
                  {
                    text: ticketOwner?.user?.licenses?.in5 || '-',
                    style: 'value'
                  }
                ]
              },
              {
                text: [
                  { text: 'Address\n', style: 'label' },
                  {
                    text: Address.getAddress(ticketOwner?.user?.address),
                    style: 'value'
                  }
                ],
                colSpan: 2
              },
              ''
            ]
          ]
        },
        layout: 'noBorders'
      });

      if (showCreditLicenceDetails) {
        content.push(
          helperPdfService.createSubHeader({
            title: 'CREDIT LICENCE DETAILS'
          })
        );
        content.push({
          table: {
            widths: ['25%', '25%', '25%', '25%'],
            body: [
              [
                {
                  text: [
                    {
                      text: `${
                        helperService.getOrganizationCountry().cca2 === 'AU'
                          ? 'Australian credit licence'
                          : 'Credit licence'
                      }\n`,
                      style: 'label'
                    },
                    {
                      text: $rootScope.CurrentOrganization?.organization?.licenses?.in1 || '-',
                      style: 'value'
                    }
                  ]
                },
                {
                  text: [
                    { text: 'Credit licence number\n', style: 'label' },
                    {
                      text: $rootScope.CurrentOrganization?.organization?.licenses?.id1 || '-',
                      style: 'value'
                    }
                  ]
                },
                {
                  text: [
                    { text: 'ABN/ACN\n', style: 'label' },
                    {
                      text: $rootScope.CurrentOrganization?.organization?.licenses?.id2 || '-',
                      style: 'value'
                    }
                  ]
                },
                {
                  text: [
                    { text: 'Phone number\n', style: 'label' },
                    {
                      text: $rootScope.CurrentOrganization?.organization?.licenses?.id3 || '-',
                      style: 'value'
                    }
                  ]
                }
              ],
              [
                {
                  text: [
                    { text: 'Address\n', style: 'label' },
                    {
                      text: $rootScope.CurrentOrganization?.organization?.licenses?.in2 || '-',
                      style: 'value'
                    }
                  ],
                  colSpan: 3
                },
                '',
                '',
                ''
              ]
            ]
          },
          layout: 'noBorders'
        });
      }
    }
    return content;
  };

  return {
    prepareAboutUsDetails
  };
};
